@if (model) {
    <div>
        <div>
            @if (isLoading) {
                <div class="fancy-loader"></div>
            } @else {
                <risk-linkable
                    #linkable
                    displayValueProp="name"
                    [(linked)]="linked"
                    [unlinked]="unlinked"
                    [hideActions]="true"
                    [orderByValueProperty]="true"
                    [disabled]="true"
                >
                </risk-linkable>
            }
        </div>
    </div>
}
